<div class="alert-analyze-container">
  <div class="analyze-header-container">
    <div class="d-flex gap5">
      <div matTooltip="Back" (click)="handleBack()" class="cursor">
        <img alt="back" src="../../../../assets/images/arrow_circle_left.svg" />
      </div>
      <div class="back-button-text">Analyze</div>
    </div>
    <div class="d-flex gap5">
      <img alt="comment" class="mt-10 cursor" src="../../../../assets/images/commentsIcon.svg"
        (click)="showComment(true)" />
    </div>
  </div>
  <div class="main-content">
    <div [ngClass]="alertDetails?.status !== 'Active' ? 'analyze-left-column' : 'analyze-left-column-active'">
      <div class="details-section">
        <div class="icon-on-left left-decoration-item"
          [ngClass]="fetchAlertState(alertDetails?.status,alertDetails?.state)"
          *ngIf="alertDetails?.status || alertDetails?.state">
          {{ fetchAlertState(alertDetails?.status, alertDetails?.state) }}
        </div>
        <div class="make-responsive-alert-details" [ngClass]="alertDetails?.status !== 'Active' ? 'alert-details-gap' : 'alert-details-gap-active'">
          <div class="info-row">
            <div class="label">Time</div>
            <div class="value">{{ alertDetails?.time ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Alert Name</div>
            <div class="value">{{ alertDetails?.alert ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Chassis Number</div>
            <div class="value">{{ alertDetails?.entityName ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Alert Description</div>
            <div class="value">{{ alertDetails?.message ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Rule ID</div>
            <div class="value">{{ alertDetails?.ruleId ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Alert Age</div>
            <div class="value">{{ alertDetails?.time ?? '-' }}</div>
          </div>
          <div class="info-row">
            <div class="label">Acknowledged By</div>
            <div class="value">{{ alertDetails?.ackBy ?? '-' }}</div>
          </div>
          <div *ngIf="alertDetails?.status !== 'Active'" class="info-row">
            <div class="label">Severity</div>
            <div class="value">{{ alertDetails?.severity | titlecase }}</div>
          </div>
          <div class="info-row">
            <div class="label">Acknowledged Time</div>
            <div class="value">{{ alertDetails?.ackTime ?? '-' }}</div>
          </div>
          <div *ngIf="alertDetails?.status !== 'Active'" class="info-row">
            <div class="label">Category</div>
            <div class="value">{{ alertDetails?.category | titlecase }}</div>
          </div>
        </div>
      </div>
      <div class="details-section alert-analyze-tab">
        <img src="../../../../assets/images/telemetry-download.svg" alt="download"
          class="cursor d-flex pse download-icon" matTooltip="Download" (click)="openDownloadPopover()" />
        <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex" (selectedTabChange)="tabChanged($event)">
          <mat-tab *ngFor="let tab of alertAnalyzeTelemetryTab" label="{{tab.label}}">
            <div class="make-responsive-telemerty-details">
              <div class="info-row" *ngFor="let details of telemetryAttributesData">
                <div class="label">{{ details?.attributeName }}</div>
                <div *ngIf="details?.attributeName !== 'Ignition Status'" class="value">{{ details?.value ?? '-' }}
                </div>
                <div *ngIf="details?.attributeName === 'Ignition Status'" class="validops-chips mt-1">{{
                  details?.value
                  ? (details?.value === 0 ? 'OFF' : 'ON') : '-' }}</div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

    </div>
    <div class="analyze-right-column">
      <div class="map-section">
        <app-leaflet-map pageType="alertAnalyze" [mapData]="masterMapData"
          [styleType]="alertDetails?.status === 'Active' ? 'alert-analyze': 'geotrace'"></app-leaflet-map>
      </div>
      <div class="details-section" *ngIf="alertDetails?.status === 'Active'">
        <div class="action-header">Action</div>
        <div class="editable-section">
          <div>
            <mat-form-field class="field" appearance="outline">
              <mat-label>Severity</mat-label>
              <mat-select [disableOptionCentering]="true" [formControl]="severity">
                <mat-option class="text-capitalize" *ngFor="let option of severityList" [value]="option?.value">
                  {{option?.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="alertDetails?.status === 'Active'">
            <mat-form-field class="field" appearance="outline">
              <mat-label>Category</mat-label>
              <mat-select [disableOptionCentering]="true" [formControl]="category">
                <mat-option class="text-capitalize" *ngFor="let option of categoryList" [value]="option?.value">
                  {{option?.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <hr class="action-hr">
        <div class="d-flex gap10 pse">
          <button class="invalid-button cursor" (click)="validateAlert('invalid')">Invalid</button>
          <button mat-raised-button class="valid-button cursor -primary" (click)="validateAlert('valid')">Valid</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-comments-listing [isCollapsed]="showComments" [alertDetails]="alertDetails" (collapse)="showComment(false)"
  [commentsList]="commentsList">
</app-comments-listing>